export default __webpack_public_path__ + "static/media/mobile_06.0a2d96fb.png";